'use strict';

import React, {Component} from 'react';

import {ExclamationOctagonFill} from 'react-bootstrap-icons';

import Card from 'react-bootstrap/Card';
import Alert from 'react-bootstrap/Alert';
import Col from "react-bootstrap/Col";

import {pluralize} from "@uw-it-sis/lib-react/lib/Utils";
import {AppContext} from "@uw-it-sis/lib-react/lib/AppContext";
import SimpleState from "@uw-it-sis/lib-react/lib/SimpleState";

import majorsStore from "./stores/MajorsStore";
import {observer} from "mobx-react";

class Majors extends Component {
    constructor(props, context) {
        super(props);
        this.store = majorsStore;
        this.appStore = context.appStore;
    }

    static contextType = AppContext;

    componentDidMount() {
        if ( this.appStore.isStudent() || this.appStore.isAdviser() ) {
            this.store.mount();
        }
    }

    componentWillUnmount() {
        this.store.unmount();
    }

    buildDoneComponent = () => {
        const {majors, premajorIndicator} = this.store.getMajorData();
        const declaredMajors = this.appStore.getMajors();
        const isPremajor = premajorIndicator === "Y";

        let declaredDisplay, majorsDisplay;

        // If reg data has majors data available, display it. Could be intended or declared based on the premajorIndicator value
        if (premajorIndicator && majors && majors.length) {
            let majorText = `${isPremajor ? "Intended" : "Declared"} ${pluralize("Major", majors.length)}`;
            let majorsList = majors.map((item, index) => {
                if (item && item.hasOwnProperty("majorName")) {
                    if (majors.length === 1) {
                        return (
                            <React.Fragment key={index}>{item.majorName}</React.Fragment>
                        )
                    } else {
                        return (
                            <li key={index}>{item.majorName}</li>
                        )
                    }
                }
            }).filter(i => i); // filter out any possible undefined list items

            if (majorsList.length > 0) {
                majorsDisplay =
                    <Col xs={12} md={6} lg={3}>
                        <dt>{majorText}:</dt>
                        <dd className="mb-0">
                            {majors.length === 1 ? majorsList : <ul className="ps-3 mb-0">{majorsList}</ul>}
                        </dd>
                    </Col>
            }
        }

        // If there is no data from reg service, or the data from reg service is the "intended" major, then use the user session data to show declared major
        if ( ( isPremajor || premajorIndicator === undefined) && declaredMajors && declaredMajors.length && this.store.hasDegreesData() ) {
            let majorsList = declaredMajors.map((item, index) => {
                let degree = this.store.getDegreeByCode(item);
                // possible a user session major code is returned that does not exist in our degree programs list; if not found skip display
                if (degree && degree.hasOwnProperty("title")) {
                    if (declaredMajors.length === 1) {
                        return (
                            <React.Fragment key={index}>{degree.title}</React.Fragment>
                        )
                    } else {
                        return (
                            <li key={index}>{degree.title}</li>
                        )
                    }
                }
            }).filter(i => i); // filter out any possible undefined list items

            if (majorsList.length > 0) {
                declaredDisplay =
                    <Col xs={12} md={6} lg={3}>
                        <dt>Declared {pluralize("Major", declaredMajors.length)}:</dt>
                        <dd className="mb-0">
                            {declaredMajors.length === 1 ? majorsList : <ul className="ps-3 mb-0">{majorsList}</ul>}
                        </dd>
                    </Col>
            }
        }

        return (
            <>
                <dl className="mb-0 row g-3">
                    <Col xs={12} md={6} lg={3}>
                        <dt>Name:</dt>
                        <dd className="mb-0">{this.appStore.getDisplayName()}</dd>
                    </Col>
                    {declaredDisplay}
                    {majorsDisplay}
                    <Col xs={12} md={6} lg={3}>
                        <a href={`https://sdb.admin.uw.edu/sisStudents/uwnetid/prefmajor.aspx`} target="_blank">Change My Intended
                            Major</a>
                    </Col>
                </dl>
            </>
        );
    }

    buildErrorComponent = () => {
        return (
            <Alert variant="danger"
                   className="d-inline-flex align-items-center mb-0 py-2 fs-7"
                   aria-live="polite"
                   aria-atomic={true}>
                <ExclamationOctagonFill aria-hidden={true} className="me-2"/>
                <span>Major Information is currently unavailable</span>
            </Alert>
        )
    }

    render() {
        if (this.appStore.isStudent() || this.appStore.isAdviser()) {
            return (
                <Card bg="transparent" className="border">
                    <Card.Header>
                        <Card.Title as="h2" className="mb-0">Major Information</Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <SimpleState
                            state={this.store.state}
                            doneComponentBuilder={this.buildDoneComponent}
                            errorComponentBuilder={this.buildErrorComponent}
                            name="AccountMajor"
                        />
                    </Card.Body>
                </Card>
            );
        } else {
            return null;
        }
    }
}

export default observer(Majors);